import React, { Component } from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import ErrorWrapper from "~/components/wrapper/ErrorWrapper";
import ContentLoader from "~/components/element/ContentLoader";
import CreatePropertyType from "../components/CreatePropertyType";
import UploadSection from "../components/UploadSection";
import PanoramasSection from "../components/PanoramasSection";
import ProcessingSection from "../components/ProcessingSection";
import EditSection from "../components/EditSection";
import Immersive3dTourAppPageStore from "~/stores/Immersive3dTourAppPageStore";
import DeniedSection from "../components/DeniedSection";
import ReplacePanoramaPage from "../components/ReplacePanoramaPage";
import TourStore from "~/stores/TourStore";
import "../styles/Immersive3dTour.less";

@observer
class AppPage extends Component {
  constructor(props) {
    super(props);

    const { immersive3dTourAppPageStore, showError } = this.props;

    const {
      tourId,
      tourJobStore,
      productStore,
      immersive3dTourFloorPlanImportModalStore,
    } = immersive3dTourAppPageStore;

    tourJobStore.updateSearchParams({ tourId });

    immersive3dTourAppPageStore
      .load()
      .catch(() => showError("An error occurred during the setup of your Immersive 3D Tour"));

    // We need all products
    productStore.pagination.itemsPerPage = 100;
    productStore.loadIndex().catch(error => showError(error.message));

    immersive3dTourFloorPlanImportModalStore.tourId = tourId;
    immersive3dTourFloorPlanImportModalStore.load().catch(error => {
      showError(error.message);
    });
  }

  componentWillUnmount() {
    const { immersive3dTourAppPageStore } = this.props;
    const { immersive3dTourTabStore } = immersive3dTourAppPageStore;

    immersive3dTourTabStore.closeUploader();
  }

  deleteImmersive3dTour() {
    const { showError, immersive3dTourAppPageStore } = this.props;
    const { immersive3dTourStore, immersive3dTourTabStore } = immersive3dTourAppPageStore;
    const { immersive3dTour } = immersive3dTourStore;

    return immersive3dTourTabStore.delete(immersive3dTour.tourId).catch(error => showError(error.message));
  }

  render() {
    const { immersive3dTourAppPageStore, gettingStarted, isMyUrbanimmersive, tourStore } = this.props;
    const {
      immersive3dTourStore,
      immersive3dTourTabStore,
      isLoading,
      isReplacePanoramaPage,
    } = immersive3dTourAppPageStore;

    if (isLoading) {
      return <ContentLoader />;
    }

    const { immersive3dTour } = immersive3dTourStore;
    const { isUploading, hasNewPanoramas, forceShowUpload, hasUppyUploadError } = immersive3dTourTabStore;
    // if user is MyUrbanimmersive type, then do not render the UploadSection, nor the Select Property Type,
    // show the GettingStarted tutorial instead.
    const showGettingStarted = gettingStarted && isMyUrbanimmersive;

    if (immersive3dTour.isDenied) {
      return (
        <DeniedSection
          immersive3dTour={immersive3dTour}
          deleteImmersive3dTourCallback={() => this.deleteImmersive3dTour()}
        />
      );
    }

    if (immersive3dTour.propertyType === null) {
      // prevent showing the Select Property Type section.
      if (showGettingStarted) {
        return gettingStarted;
      }

      return <CreatePropertyType immersive3dTourAppPageStore={immersive3dTourAppPageStore} />;
    }

    if (!forceShowUpload && !isUploading && !hasUppyUploadError) {
      if (isReplacePanoramaPage && immersive3dTourAppPageStore.hasCompletedInitialProcessing) {
        return <ReplacePanoramaPage immersive3dTourAppPageStore={immersive3dTourAppPageStore} />;
      }

      if (!hasNewPanoramas && immersive3dTourAppPageStore.hasCompletedProcessingWithSuccess) {
        return (
          <EditSection
            isMyUrbanimmersive={isMyUrbanimmersive}
            immersive3dTourAppPageStore={immersive3dTourAppPageStore}
            tourStore={tourStore}
          />
        );
      }

      if (immersive3dTourAppPageStore.isProcessing) {
        return <ProcessingSection immersive3dTourAppPageStore={immersive3dTourAppPageStore} />;
      }

      if (hasNewPanoramas) {
        return <PanoramasSection immersive3dTourAppPageStore={immersive3dTourAppPageStore} />;
      }
    }

    // prevent showing the UploadSection
    if (showGettingStarted) {
      return gettingStarted;
    }

    return <UploadSection immersive3dTourAppPageStore={immersive3dTourAppPageStore} />;
  }
}

AppPage.propTypes = {
  immersive3dTourAppPageStore: PropTypes.instanceOf(Immersive3dTourAppPageStore),
  tourStore: PropTypes.instanceOf(TourStore),
  // used as a tutorial for the UI Capture APP.
  gettingStarted: PropTypes.element,
  isMyUrbanimmersive: PropTypes.bool,
};

export default ErrorWrapper(AppPage);
